"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_jss_1 = __importDefault(require("react-jss"));

var styles = {
  line: {
    padding: '4px 0',
    margin: '4px 0',
    borderBottom: 'solid 1px #CCCCCC'
  },
  lineName: {
    fontSize: 10,
    fontWeight: 'bold'
  },
  lineValue: {
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
};

var LineItem = function LineItem(_a) {
  var name = _a.name,
      value = _a.value,
      classes = _a.classes;
  return react_1.default.createElement("div", {
    className: classes.line
  }, react_1.default.createElement("div", {
    className: classes.lineName
  }, name), react_1.default.createElement("div", {
    className: classes.lineValue
  }, value));
};

exports.default = react_jss_1.default(styles)(LineItem);